function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigation } from "@react-navigation/native";
import { useCallback, useLayoutEffect, useState } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { graphql } from "@oui/lib/src/graphql/tada";
import { Button } from "../components/Button";
import { EditLessonsLearnedForm } from "../components/EditLessonsLearnedForm/EditLessonsLearnedForm";
import { HeaderButtons, HeaderItem } from "../components/HeaderButtons";
import { ScrollView } from "../components/ScrollView";
import { UnsavedChangesModal } from "../components/UnsavedChangesModal";
import { View } from "../components/View";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
export var EditLessonsLearnedQuery = graphql("\n  query EditLessonsLearned {\n    lessonLearned {\n      createdAt\n      session\n      text\n    }\n  }\n");
export var SaveLessonLearnedMutation = graphql('\n  mutation SaveLessonLearned($session: String!, $text: Any!) {\n    kvRespond(context: $session, key: "lessonLearned", data: $text) {\n      __typename\n      context\n      key\n      value\n    }\n  }\n');
/**
 * This screen allows users to edit their "lessons learned" entries.
 *
 * Uses the <https://ouihealth.atlassian.net/browse/APICORE-81> to fetch
 * existing lesson learned entries.
 *
 * Uses the <https://ouihealth.atlassian.net/browse/APICORE-89> to save changes.
 *
 * Displays a list of editable lesson learned entries using the
 * <https://ouihealth.atlassian.net/browse/LESSONS-5>  component.
 *
 *
 *
 * **Navigation**:
 *
 * The back arrow (cancel button) will redirect the user to the
 * '<https://ouihealth.atlassian.net/browse/OTX401-34> .
 *
 * Attempts to navigate away with unsaved changes will trigger an
 * <https://ouihealth.atlassian.net/browse/APPCORE-2> .
 *
 *
 *
 * [Figma file](https://www.figma.com/file/LIbbnQ2oap9fGyvizt5KnA/Lessons-learned?type=design\&node-id=0%3A1\&mode=design\&t=BZzmA4MSrjp5XCsj-1)
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-12}
 */ export function EditLessonsLearned() {
    var safeArea = useSafeAreaInsets();
    var $t = useI18n().$t;
    var theme = useTheme().theme;
    var _useQuery = useQuery(EditLessonsLearnedQuery), data = _useQuery.data, refetch = _useQuery.refetch;
    var _useMutation = _sliced_to_array(useMutation(SaveLessonLearnedMutation), 1), saveLesson = _useMutation[0];
    var navigation = useNavigation();
    var _useState = _sliced_to_array(useState([]), 2), unsavedData = _useState[0], setUnsavedData = _useState[1];
    var onSave = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var promises;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = unsavedData.map(function(lesson) {
                        var _data_lessonLearned;
                        var currentValue = data === null || data === void 0 ? void 0 : (_data_lessonLearned = data.lessonLearned) === null || _data_lessonLearned === void 0 ? void 0 : _data_lessonLearned.find(function(less) {
                            return less.session === lesson.session;
                        });
                        return (currentValue === null || currentValue === void 0 ? void 0 : currentValue.text) !== lesson.text ? saveLesson({
                            variables: {
                                session: lesson.session,
                                text: lesson.text
                            }
                        }) : Promise.resolve();
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        refetch()
                    ];
                case 2:
                    _state.sent();
                    setUnsavedData([]);
                    setTimeout(function() {
                        navigation.goBack();
                    }, 0);
                    return [
                        2
                    ];
            }
        });
    }), [
        unsavedData,
        data,
        saveLesson,
        refetch,
        navigation
    ]);
    var onEditLessonsLearned = useCallback(function(updatedLessons) {
        setUnsavedData(updatedLessons);
    }, []);
    useLayoutEffect(function() {
        navigation.setOptions({
            headerTitle: $t({
                id: 'EditLessonsLearned_headerTitle',
                defaultMessage: 'Edit lessons learned'
            }),
            headerRight: function() {
                return /*#__PURE__*/ _jsx(HeaderButtons, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        text: $t({
                            id: 'EditLessonsLearned_saveButton',
                            defaultMessage: 'Save'
                        }),
                        testID: "EditLessonsLearned_saveButton",
                        alignSelf: "flex-start",
                        onPress: onSave,
                        style: {
                            paddingHorizontal: 14
                        }
                    })
                });
            },
            headerLeft: function(param) {
                var tintColor = param.tintColor;
                return /*#__PURE__*/ _jsx(HeaderButtons, {
                    left: true,
                    children: /*#__PURE__*/ _jsx(HeaderItem, {
                        testID: "EditLessonsLearned_cancelButton",
                        "aria-label": $t({
                            id: 'EditLessonsLearned_cancelButton',
                            defaultMessage: 'Cancel'
                        }),
                        title: "",
                        onPress: function() {
                            navigation.goBack();
                        },
                        iconName: "close",
                        color: tintColor
                    })
                });
            }
        });
    }, [
        $t,
        navigation,
        onSave
    ]);
    var _data_lessonLearned;
    return /*#__PURE__*/ _jsxs(ScrollView, {
        bottomOverflowColor: theme.color.gray800,
        style: {
            flex: 1,
            backgroundColor: theme.color.gray800
        },
        contentContainerStyle: {
            paddingBottom: safeArea.bottom + 18,
            padding: 18
        },
        testID: "EditLessonsLearned_scrollView",
        children: [
            /*#__PURE__*/ _jsx(View, {
                style: {
                    paddingRight: 9
                },
                children: /*#__PURE__*/ _jsx(EditLessonsLearnedForm, {
                    data: unsavedData.length > 0 ? unsavedData : (_data_lessonLearned = data === null || data === void 0 ? void 0 : data.lessonLearned) !== null && _data_lessonLearned !== void 0 ? _data_lessonLearned : [],
                    onEdit: onEditLessonsLearned
                })
            }),
            /*#__PURE__*/ _jsx(UnsavedChangesModal, {
                hasUnsavedChanges: unsavedData.length > 0,
                onConfirm: /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(param) {
                        var continueNavigation;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    continueNavigation = param.continueNavigation;
                                    return [
                                        4,
                                        onSave()
                                    ];
                                case 1:
                                    _state.sent();
                                    continueNavigation();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                confirmText: $t({
                    id: 'EditLessonsLearned_confirmationModal_confirmButton',
                    defaultMessage: 'Save'
                }),
                cancelText: $t({
                    id: 'EditLessonsLearned_confirmationModal_cancelButton',
                    defaultMessage: 'Discard'
                }),
                title: $t({
                    id: 'EditLessonsLearned_confirmationModal_title',
                    defaultMessage: 'Save changes?'
                }),
                description: $t({
                    id: 'EditLessonsLearned_confirmationModal_description',
                    defaultMessage: 'You’ve made changes. Would you like to save them before leaving?'
                })
            })
        ]
    });
}
